import React from "react";
import Select from "react-select";
import { franchises57Options } from "../../constants/Customer";

const FranchisePicker = ({
	franchise,
	action,
	required,
	franchiseList = franchises57Options,
}) => {
	return (
		<div>
			<Select
				name="form-field-name"
				placeholder="Franchise..."
				value={franchiseList.filter((v) => v.value === franchise)}
				onChange={action}
				isClearable={false}
				isSearchable={true}
				options={franchiseList}
			/>

			{required && (
				<input
					tabIndex={-1}
					autoComplete="off"
					style={{ opacity: 0, height: 0 }}
					value={franchise}
					required={true}
				/>
			)}
		</div>
	);
};

export default FranchisePicker;
